import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'
import './structured.css'
import './world.css'
import './schedule.css'
import './event.css'
import './authoring.css'
import './responsive.css'

const root = document.getElementById('root')
if (!root) throw new Error('ExtraNPCs Studio root element is missing')
createRoot(root).render(<StrictMode><App /></StrictMode>)
